import { BASE_URL } from '../endpoints'
import { get } from '../https'
interface school {
  id: string
  userId: string
  schoolId: string
  roleId: string
  updatedAt: string
  createdAt: string
  userName: string
  role: string
  name: string
  logo: string
}

interface schoolResponse {
  status: string
  data: school[]
}
export const getAllSchools = (): Promise<unknown> => {
  return get(`${BASE_URL}/school-members/my`)
}

export const getAllGroupsSchools = (): Promise<unknown> => {
  return get(`${BASE_URL}/groups/schools`)
}

export const getSchoolsData = async (): Promise<school[]> => {
  const response = (await getAllSchools()) as schoolResponse

  if (response?.status != 'successful') {
    console.log('error', response)
  }
  return response?.data
}

export const getGroupsSchoolsData = async (): Promise<schoolResponse> => {
  const response = (await getAllGroupsSchools()) as schoolResponse

  if (response?.status != 'successful') {
    console.log('error', response)

  }
  return response
}
